import { inject, Injectable, Injector } from '@angular/core';
import { Convention } from '@common/core/models';
import { IBitfApiRequest } from '@common/interfaces';
import { BitfApiService } from '@common/libs/bitforce/core/services/api/bitf-api.service';
import { StoreService } from '../store.service';

@Injectable({
  providedIn: 'root',
})
export class ConventionsService extends BitfApiService {
  /**
   * Imports
   */
  private storeService = inject(StoreService);

  constructor(public injector: Injector) {
    super('conventions', injector);
  }

  getConventions(apiRequest: IBitfApiRequest) {
    return this.get<Convention>({
      populate: '*',
      filter: {
        company: {
          documentId: { $in: this.storeService.store?.group?.companies?.map(c => c.documentId) },
        },
        ...apiRequest.filter,
      },
      ...apiRequest,
    });
  }

  getConventionDetails(id: string) {
    return this.getById<Convention>({ id: id });
  }
}
